import { render } from "./Services.vue?vue&type=template&id=694ca935&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=694ca935&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-694ca935"

export default script